import Vue from 'vue';
import Modal from 'src/components/widgets/Modal.vue';
export default Vue.extend({
    // required for old vee-validate2
    $_veeValidate: { validator: 'new' },
    name: 'ModalEditText',
    components: {
        Modal,
    },
    props: {
        header: { type: String, default: '' },
        caption: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        cancelButtonText: { type: String, default: 'Cancel' },
        saveButtonText: { type: String, default: 'Save' },
    },
    data() {
        return {
            proposedNewText: '',
            context: undefined,
        };
    },
    beforeDestroy() {
    },
    methods: {
        show(proposed = '', context = undefined) {
            this.proposedNewText = proposed;
            this.context = context;
            this.$refs.editModal.show();
            this.$nextTick(() => {
                this.$refs.newTextInput.focus();
                this.$refs.newTextInput.select();
            });
        },
        save() {
            this.$emit('save', this.proposedNewText, this.context);
            this.$refs.editModal.hide();
            this.proposedNewText = '';
            this.context = undefined;
        },
        cancel() {
            this.proposedNewText = '';
            this.context = undefined;
            this.$emit('cancel');
        }
    },
});
